import { useMutation, useQuery } from "@tanstack/react-query";
import { analysisService, BCHOverlayParams, ExternalDataTemplateDownload, ExternalDataUpload, IHMAPricingData } from "../services/analysisService";
import { useTranslation } from "react-i18next";

export const useUploadExternalData = () => {
  return useMutation({
    mutationFn: (data: ExternalDataUpload) => analysisService.uploadExternalData(data),
  });
};

export const useDownloadExternalDataTemplate = () => {
  return useMutation({
    mutationFn: (data: ExternalDataTemplateDownload) => analysisService.downloadExternalDataTemplate(data),
  });
};

export const useSubmitIHMAPricingData = () => {
  return useMutation({
    mutationFn: (data: IHMAPricingData) => analysisService.submitIHMAPricingData(data),
  });
};

export const useGetIhmaPriceBreakdown = (
  params: {
    productId: number;
    startMonthEpoch?: number;
    endMonthEpoch?: number;
    timezoneOffset?: number;
  },
  enabled: boolean = true
) => {
  const { i18n } = useTranslation();
  return useQuery({
    queryKey: ['ihmapricebreakdown', params, i18n.language],
    queryFn: () => analysisService.getIhmaPriceBreakdown(params),
    enabled,
    staleTime: 5 * 60 * 1000, 
  });
};

export const useGetBCHOverlay = (
  params: BCHOverlayParams,
  enabled: boolean = true
) => {
  return useQuery({
    queryKey: ['bchoverlay', params],
    queryFn: () => analysisService.getBCHOverlay(params),
    enabled,
    staleTime: 60 * 1000, 
  });
};
